import { shuffleArray } from '@spotahome/ui-library/src/tenant/components/utils/arrayUtils';

const PROPORTION_100 = 100;
const PROPORTION_75 = 75;
const PROPORTION_50 = 50;
const PROPORTION_25 = 25;
const PROPORTION_10 = 10;

export const calculateProportionalValueOriginal = length => {
  let proportionalValue;
  if (length < 10) {
    proportionalValue = PROPORTION_100;
  } else if (length >= 10 && length <= 20) {
    proportionalValue = PROPORTION_75;
  } else if (length > 20 && length <= 40) {
    proportionalValue = PROPORTION_50;
  } else {
    proportionalValue = PROPORTION_25;
  }

  return Math.round(length * (proportionalValue / 100));
};

export const calculateProportionalValueVariant = length => {
  let proportionalValue;
  if (length < 6) {
    return 1;
  } else if (length >= 6 && length <= 39) {
    proportionalValue = PROPORTION_25;
  } else {
    proportionalValue = PROPORTION_10;
  }

  return Math.round(length * (proportionalValue / 100));
};

export const calculateProportionalValue = (
  length,
  useAlternativeProportions
) => {
  if (useAlternativeProportions) {
    return calculateProportionalValueVariant(length);
  }
  return calculateProportionalValueOriginal(length);
};

export const mergeSoldOutMarkers = (
  markers,
  soldOutMarkers,
  useAlternativeProportions = false
) => {
  const nMarkers = markers.length;
  const maxSoMarkers = calculateProportionalValue(
    nMarkers,
    useAlternativeProportions
  );
  const cappedSoMarkers = soldOutMarkers.slice(0, maxSoMarkers);

  return markers.reduce((acc, marker, i) => {
    const withMarker = [...acc, marker];
    const soToInsert = i % 2 ? null : cappedSoMarkers[Math.floor(i / 2)];

    return soToInsert ? [...withMarker, soToInsert] : withMarker;
  }, []);
};

export const mergeSoldOutMarkersRandom = (
  markers,
  soldOutMarkers,
  seed,
  useAlternativeProportions = false
) => {
  const nMarkers = markers.length;
  const maxSoMarkers = calculateProportionalValue(
    nMarkers,
    useAlternativeProportions
  );

  const shuffledSoldOutMarkers = shuffleArray(soldOutMarkers, seed);
  const cappedSoMarkers = shuffledSoldOutMarkers.slice(0, maxSoMarkers);

  const availablePositions = shuffleArray(
    Array.from({ length: nMarkers - 2 }, (_, i) => i + 2), // exclude the two first positions
    seed
  );

  const insertPositions = availablePositions.slice(0, cappedSoMarkers.length);

  const result = [...markers];
  insertPositions.forEach((pos, idx) => {
    result.splice(pos + idx, 0, cappedSoMarkers[idx]);
  });

  return result;
};

export const splitMarkers = (markerList = []) => {
  const soMarkers = [];
  const markers = [];
  markerList.forEach(marker => {
    if (marker.so) {
      soMarkers.push(marker);
    } else {
      markers.push(marker);
    }
  });
  return { soMarkers, markers };
};
